<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="fmp"><span epub:type="pagebreak" id="page_vii" title="vii">Nothing exists.</span></p>
<p class="fmp1">If anything exists, it is incomprehensible.</p>
<p class="fmp1">If anything was comprehensible,<br/>it would be incommunicable.</p>
<p class="fmpr">—Gorgias<span epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?127634d2